<div class="actions">
    <div *ngIf="isActiveRoute('/administration/users')">
        <button mat-mini-fab color="accent" matTooltip="{{'administration.users.add' | translate}}"
            (click)="onAddUser()">
            <fa-icon [icon]="faUserAdd" size="lg"></fa-icon>
        </button>
    </div>
    <div *ngIf="isActiveRoute('/administration/shops') && authService.hasPermission(permissionEnum.AddShop)">
        <button mat-mini-fab color="accent" matTooltip="{{'administration.shops.add' | translate}}"
            (click)="onAddShop()">
            <fa-icon [icon]="faCartPlus" size="lg"></fa-icon>
        </button>
    </div>
    <div *ngIf="isActiveRoute('/administration/printers') && authService.hasPermission(permissionEnum.AddPrinter)">
        <button mat-mini-fab color="accent" matTooltip="{{'administration.printers.add' | translate}}"
            (click)="onAddPrinter()">
            <fa-layers [fixedWidth]="true" size="lg">
                <fa-icon [icon]="faPrint" transform="left-3"></fa-icon>
                <fa-icon [icon]="faPlus" transform="shrink-7 up-4 right-8"></fa-icon>
            </fa-layers>
        </button>
    </div>

    <div *ngIf="isActiveRoute('/reports/sales-statement')">        
        <button *ngIf="authService.hasPermission(permissionEnum.PrintBasedOnItems)" mat-mini-fab color="accent" matTooltip="{{'reports.sales-statement.download-based-on-items' | translate}}"
            (click)="onDownloadSalesStatementBasedOnItemsCsv()" [disabled]="!salesStatementService.canDownloadBasedOnItems">
            <fa-icon [icon]="faDownloadSalesBasedOnItemsStatement" size="lg"></fa-icon>
        </button>
        <button mat-mini-fab color="accent" matTooltip="{{'reports.sales-statement.print' | translate}}"
            (click)="onPrintSalesStatement()" [disabled]="!salesStatementService.canPrint">
            <fa-icon [icon]="faPrintSalesStatement" size="lg"></fa-icon>
        </button>
        <button mat-mini-fab color="accent" matTooltip="{{'reports.sales-statement.download' | translate}}" 
            [matMenuTriggerFor]="downloadMenu" [disabled]="!salesStatementService.canDownload">
            <fa-icon [icon]="faDownloadSalesStatement" size="lg"></fa-icon>
        </button>
        <mat-menu #downloadMenu="matMenu" class="button-menu" xPosition="before">
            <button mat-menu-item (click)="onDownloadSalesStatement('pdf')">
                <fa-icon [icon]="faPdf" size="lg"></fa-icon>
                <span>{{'reports.sales-statement.download' | translate}} PDF</span>
            </button>
            <button mat-menu-item (click)="onDownloadSalesStatement('csv')">
                <fa-icon [icon]="faCsv" size="lg"></fa-icon>
                <span>{{'reports.sales-statement.download' | translate}} CSV</span>
            </button>
            <button mat-menu-item (click)="onDownloadSalesStatement('xlsx')">
                <fa-icon [icon]="faXlsx" size="lg"></fa-icon>
                <span>{{'reports.sales-statement.download' | translate}} XLSX</span>
            </button>
        </mat-menu>
    </div>

    <div *ngIf="isActiveRoute('/documents/receipts') || isActiveRoute('/documents/daily-reports') || isActiveRoute('/documents/non-fiscals')">
        <button mat-mini-fab color="accent" matTooltip="{{'documents.print-selected' | translate}}"
            [disabled]="!printPreviewService.hasSelectedDocuments()"
            (click)="onPrintDocumentView()">
            <fa-icon [icon]="faPrintDocuments" size="lg"></fa-icon>
        </button>
    </div>

    <div *ngIf="isActiveRoute('/reports/printers-status')">
        <button mat-mini-fab color="accent" matTooltip="{{'reports.printers-status.download-xlsx' | translate}}"
            (click)="onDownloadPrintersStatus('xlsx')">
            <fa-icon [icon]="faXlsx" size="lg"></fa-icon>
        </button>
    </div>
</div>